module.exports = __webpack_public_path__ + "assets/img/img39.2ec5fcab.png";